module.exports = __webpack_public_path__ + "img/left_building.c8eb7ea4.png";